import { styled } from '@mui/material/styles';

const StyledCountryCodeLabel = styled('div')`
  display: flex;
  align-items: center;
`;

export default StyledCountryCodeLabel;
